<template>
    <div class="page-wrapper" :class="[theme ? theme : 'default']">
        <div class="action-bar">
            <span class="title">{{curTitle}}</span>
            <van-icon name="arrow-left" color="#ffffff" size="20px" class="icon-back" @click="handleBack" v-if="canBack"/>
        </div>
        <div class="page-content">
            <div class="page-content__inner"><slot></slot></div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Layout",
        props: {
            theme: String,
            title: String,
            canBack: {
                type: Boolean,
                default: true
            }
        },
        computed: {
            curTitle() {
                return this.title ? this.title : this.pageTitle;
            }
        },
        data() {
            return {
                pageTitle: ''
            }
        },
        methods: {
            handleBack() {
                this.$router.back();
            }
        },
        mounted() {
            this.pageTitle = this.$route.name;
        }
    }
</script>